import React from 'react';
import LandPageTypes from '../LandPageTypes';
import AdminPageTypes from '../AdminPageTypes';
import '../../../resources/css/admin.css';
import Credenciamento from '../pages/Credenciamento.jsx';
import Paises from '../pages/Paises.jsx';
import Nucleos from '../pages/Nucleos.jsx';
import Loading from '../pages/Loading.jsx';
import Blank from '../pages/Blank.jsx';
import Cidades from '../pages/Cidades.jsx';
import Events from '../pages/Events.jsx';
import Cursos from '../pages/Cursos.jsx';
import Apostilas from '../pages/Apostilas.jsx';
import Impressoras from '../pages/Impressoras.jsx';
import Participantes from '../pages/Participantes.jsx';
import Importacao from '../pages/Importacao.jsx';
import ImportacaoProdutos from '../pages/ImportacaoProdutos.jsx';
import _ from 'lodash';
import ParticipantesLimited from "../pages/ParticipantesLimited.jsx";
import Loja from "../pages/Loja.jsx";
import RelatorioDashboard from "../pages/RelatorioDashboard.jsx";
import RelatorioVendasTotais from "../pages/RelatorioVendasTotais.jsx";
import RelatorioVendasDosNucleos from "../pages/RelatorioVendasDosNucleos.jsx";
import RelatorioVendasParaNucleos from "../pages/RelatorioVendasParaNucleos.jsx";
import RelatorioVendasPorProdutos from "../pages/RelatorioVendasPorProdutos.jsx";
import RelatorioCarrinhosPagos from "../pages/RelatorioCarrinhosPagos.jsx";
import RelatorioVendasPorPagamento from "../pages/RelatorioVendasPorPagamento.jsx";
import RelatorioCompradoresPorProduto from "../pages/RelatorioCompradoresPorProduto.jsx";
import RelatorioApostilasPorNucleo from "../pages/RelatorioApostilasPorNucleo.jsx";
import DistribuicaoVendas from "../pages/DistribuicaoVendas.jsx";
import AcumuladoVendas from '../pages/AcumuladoVendas.jsx';
import Presenca from "../pages/Presenca.jsx";
import Perfis from '../pages/Perfis.jsx';
import Usuarios from '../pages/Usuarios.jsx';
import Produtos from '../pages/Produtos.jsx';
import Emails from '../pages/Emails.jsx';
import Sorteio from '../pages/Sorteio.jsx';
import LojaPedidos from '../pages/LojaPedidos.jsx';
import Permissions from '../../domain/Permissions';

class Admin extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const app = this.props.app;

        if (app.landPage !== LandPageTypes.ADMIN)
            return null;

        const loading = app.adminPage === AdminPageTypes.LOADING;
        const token = this.props.token;
        const events = this.props.events;
        const menuItems = this.props.menuItems;
        const user = this.props.user;

        const menu = menuItems
            .filter(menuItem => menuItem.render !== false)
            .map(menuItem => {
                return {
                    name: menuItem.name,
                    active: app.adminPage === menuItem.type,
                    onClick: (e) => {
                        e.preventDefault();
                        if (loading === true) return;
                        events.onChooseMenu(menuItem.type, token);
                    },
                    responsive: { visible: menuItem.responsive },
                    permissions: menuItem.permissions,
                };
            });

        return (
            <div>
                <nav className="navbar navbar-inverse navbar-fixed-top">
                    <div className="container-fluid">
                        <div className="navbar-header">
                            <button type="button" className="navbar-toggle collapsed" data-toggle="collapse" data-target="#navbar" aria-expanded="false" aria-controls="navbar">
                                <span className="sr-only">Toggle navigation</span>
                                <span className="icon-bar"></span>
                                <span className="icon-bar"></span>
                                <span className="icon-bar"></span>
                            </button>
                            <a className="navbar-brand" href="#">SGE</a>
                        </div>
                        <div id="navbar" className="navbar-collapse collapse">
                            <ul className="nav navbar-nav navbar-right">
                                <li key="username">
                                    <a>Olá, {user.username}!</a>
                                </li>
                                {menu.map(getRenderMenuCallback(true, user))}
                            </ul>
                        </div>
                    </div>
                </nav>

                <div className="container-fluid">
                    <div className="row">
                        <div className="col-sm-3 col-md-2 sidebar">
                            <ul className="nav nav-sidebar">
                                {menu.map(getRenderMenuCallback(false, user))}
                            </ul>
                        </div>
                        <div className="col-sm-9 col-sm-offset-3 col-md-10 col-md-offset-2 main">
                            <Credenciamento {...this.props} />
                            <Paises {...this.props} />
                            <Nucleos {...this.props} />
                            <Loading {...this.props} />
                            <Cidades {...this.props} />
                            <Events {...this.props} />
                            <Cursos {...this.props} />
                            <Apostilas {...this.props} />
                            <Impressoras {...this.props} />
                            <Participantes {...this.props} />
                            <ParticipantesLimited {...this.props} />
                            <Importacao {...this.props} />
                            <ImportacaoProdutos {...this.props} />
                            <Loja {...this.props} />
                            <LojaPedidos {...this.props} />
                            <RelatorioDashboard {...this.props} />
                            <RelatorioVendasTotais {...this.props} />
                            <RelatorioVendasDosNucleos {...this.props} />
                            <RelatorioVendasParaNucleos {...this.props} />
                            <RelatorioVendasPorProdutos {...this.props} />
                            <RelatorioVendasPorPagamento {...this.props} />
                            <RelatorioCarrinhosPagos {...this.props} />
                            <RelatorioCompradoresPorProduto {...this.props} />
                            <RelatorioApostilasPorNucleo {...this.props} />
                            <DistribuicaoVendas {...this.props} />
                            <AcumuladoVendas {...this.props} />
                            <Presenca {...this.props} />
                            <Perfis {...this.props} />
                            <Usuarios {...this.props} />
                            <Produtos {...this.props} />
                            <Emails {...this.props} />
                            <Sorteio {...this.props} />
                            <Blank {...this.props} />
                        </div>
                    </div>
                </div>
            </div>
        );

        function getRenderMenuCallback(responsive, user) {

            const storeTitle = (fullName, user) => {
                const allComposedStorePermissions = [Permissions.STORE_CHECKOUT, Permissions.CHECKOUT_DELIVERY, Permissions.STORE_CHECKOUT_DELIVERY];
                const hasSingleComposedStore = allComposedStorePermissions.filter((permission) => user.hasPermission(permission.name)).length == 1;
                return hasSingleComposedStore ? 'Loja' : fullName;
            };

            const title = (item, user) => {
                return item.name.startsWith('Loja') ? storeTitle(item.name, user) : item.name;
            };

            return function (item) {
                let valid = false;

                const itemName = title(item, user);

                if (item.permissions && item.permissions.length > 0) {
                    _.each(item.permissions, function (permission) {
                        if (user.hasPermission(permission.name)) {
                            valid = true;
                        }
                    });
                } else {
                    // Se item.permissions === null, então menu é válido pra qualquer perfil
                    valid = true;
                }

                if (valid === false)
                    return null;

                if (responsive === true) {
                    if (item.responsive && item.responsive.visible === true) {
                        return (
                            <li key={item.name}>
                                <a href="#" onClick={item.onClick}>{itemName}</a>
                            </li>
                        );
                    } else {
                        if (item.active === true) {
                            return (
                                <li key={item.name} className="active hidden-sm hidden-md hidden-lg"><a
                                    href="#">{itemName}{' '}<span
                                    className="sr-only">(current)</span></a></li>
                            );
                        } else {
                            return (
                                <li key={item.name} className="hidden-sm hidden-md hidden-lg">
                                    <a href="#" onClick={item.onClick}>{itemName}</a>
                                </li>
                            );
                        }
                    }
                } else {
                    if (item.active === true) {
                        return (
                            <li key={item.name} className="active"><a href="#">{itemName}{' '}<span
                                className="sr-only">(current)</span></a></li>
                        );
                    } else {
                        return (
                            <li key={item.name}><a href="#" onClick={item.onClick}>{itemName}</a></li>
                        );
                    }
                }
            };
        }
    }
}

export default Admin;



// WEBPACK FOOTER //
// src/views/landpages/Admin.jsx